import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import NoIndexHead from '../components/NoIndexHead';

const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[10],
  maxWidth: 450,
  width: '100%',
}));

const AuthLayout = ({ children }) => {
  return (
    <StyledContainer>
      <NoIndexHead title="Loksy" />
      <StyledPaper elevation={3}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom color="primary" fontWeight="bold">
            LOCSY Admin
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sign in to access the admin dashboard
          </Typography>
        </Box>
        {children}
      </StyledPaper>
    </StyledContainer>
  );
};

export default AuthLayout;

